import { Button, type ButtonProps } from '@iconik-io/uad';

import { useFormContext } from '../app_form_context';

type SubmitButtonProps = Omit<ButtonProps, 'type' | 'isPending'>;

/**
 * Submit button that automatically shows a pending state while the form is submitting.
 *
 * Must be rendered inside a `<form.AppForm>` wrapper.
 */
export function SubmitButton(props: SubmitButtonProps) {
  const { children = 'Submit', ...rest } = props;
  const form = useFormContext();

  return (
    <form.Subscribe selector={(state) => state.isSubmitting}>
      {(isSubmitting) => (
        <Button
          type="submit"
          variant="primary"
          isPending={isSubmitting}
          {...rest}
        >
          {children}
        </Button>
      )}
    </form.Subscribe>
  );
}
